import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Notifications from 'vue-notification';
import {uiBus} from "./plugins/uiBus";
import {icons} from "./plugins/icons";
import {EventEmitter} from "events";
import {i18n, initLanguage} from '@/helpers/translations';
import {IOnOffHandlers, onOffHandlers} from "bonomo/dist";
import "./plugins/vueQrCode.ts";
import {UrlHelper} from "@/helpers/UrlHelper";

require("./plugins/axios");

Vue.use(Notifications);
Vue.config.productionTip = false;

declare module 'vue/types/vue' {
  interface Vue {
    $uiBus: EventEmitter;
    $ons: (o: IOnOffHandlers, currentOns?: IOnOffHandlers) => IOnOffHandlers;
    $offs: (offs: IOnOffHandlers) => void;
    $date: (d: string) => string;
    $datim: (d: string) => string;
    $icons: any;
    $comingUp: () => void;
    $canAction: (a: string) => boolean;
  }
}

Vue.use(onOffHandlers, {
  uiBus: uiBus,
});

Vue.prototype.$icons = icons;
Vue.prototype.$comingUp = function() {
  uiBus.emit('info', i18n.t('common.comingUp').toString());
}
// fetchActionAccessLevels is debounced so loading will happen only once... But we will emit as many loaded events as
//  many times this.$canAction is called. This could be simplified to dispatch only when not loaded yet (and check that
//  nothing depends on an event emitted by a .$canAction call)
Vue.prototype.$canAction = function(action: string) {
  store.dispatch('authModule/fetchActionAccessLevels');
  return store.getters['authModule/canAction'](action);
}

initLanguage();

const legacyPublicUrl = UrlHelper.legacyPublicUrl();
if (legacyPublicUrl) {
  window.location.replace(legacyPublicUrl);
} else {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}
